import Controller from 'lib/controller'
import ImageListView from 'bundle/expat_insider/view/image_list'
import FullViewportImage from 'component/full_viewport_image/full_viewport_image'

const ExpatInsiderController = Controller.extend({
    events: {
        'click .js-focus-and-select': '_focusAndSelect',
    },

    initialize() {
        this.$('.js-full-viewport-image').each((index, el) => {
            this.initSubview(FullViewportImage, { el })
        })

        this.$('.js-imageList').each((index, el) => {
            this.initSubview(ImageListView, { el })
        })
    },

    _focusAndSelect({ target }) {
        target.focus()
        target.select()
    },
})

export default new ExpatInsiderController()
